import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

import { Content, Text, Container, TextWrapper, EndSession } from './timeout.styles';
import { ICON_WINNOW_LOGO } from '../../icon';
import { WhiteIcon } from '../snackbarRender.styles';
import messages from '../snackbar.messages';

export class Timeout extends PureComponent {
  static propTypes = {
    state: PropTypes.string.isRequired,
    endTimestamp: PropTypes.number,
    isBookingActive: PropTypes.bool,
    closeBooking: PropTypes.func,
    closeKeyboard: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      timeLeft: '00:00',
    };

    this.timeLeftInterval = setInterval(this.setTimeLeft, 100);
  }

  componentDidMount() {
    this.props.closeKeyboard();
  }

  componentWillUnmount() {
    clearInterval(this.timeLeftInterval);
  }

  setTimeLeft = () => {
    const diff = Math.max(moment.unix(this.props.endTimestamp).diff(moment()), 0);
    this.setState({
      timeLeft: moment()
        .startOf('hour')
        .milliseconds(diff)
        .format('mm:ss'),
    });
  };

  handleSnackbarClick = () => document.body.dispatchEvent(new Event('resetTimeout'));

  handleEndSession = () => this.props.closeBooking();

  render() {
    return (
      <Container state={this.props.state}>
        <Content onClick={this.handleSnackbarClick}>
          <TextWrapper>
            <WhiteIcon name={ICON_WINNOW_LOGO} size={34} />
            <Text>
              {this.props.isBookingActive ? (
                <Fragment>
                  <FormattedMessage {...messages.timeoutBooking} />
                  &nbsp;
                  <EndSession onClick={this.handleEndSession}>
                    <FormattedMessage {...messages.endSession} />
                  </EndSession>
                </Fragment>
              ) : (
                <FormattedMessage {...messages.timeoutExperience} />
              )}
            </Text>
          </TextWrapper>
          {this.state.timeLeft}
        </Content>
      </Container>
    );
  }
}
